// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/driver_certification_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverCertification } from "./driver_certification_pb.js";
import { file_transportation_v1_driver_certification } from "./driver_certification_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/driver_certification_events.proto.
 */
export const file_transportation_v1_driver_certification_events: GenFile = /*@__PURE__*/
  fileDesc("CjN0cmFuc3BvcnRhdGlvbi92MS9kcml2ZXJfY2VydGlmaWNhdGlvbl9ldmVudHMucHJvdG8SEXRyYW5zcG9ydGF0aW9uLnYxIvgBChhEcml2ZXJDZXJ0aWZpY2F0aW9uRXZlbnQSRQoHY3JlYXRlZBgBIAEoCzIyLnRyYW5zcG9ydGF0aW9uLnYxLkRyaXZlckNlcnRpZmljYXRpb25DcmVhdGVkRXZlbnRIABJFCgd1cGRhdGVkGAIgASgLMjIudHJhbnNwb3J0YXRpb24udjEuRHJpdmVyQ2VydGlmaWNhdGlvblVwZGF0ZWRFdmVudEgAEkUKB2RlbGV0ZWQYAyABKAsyMi50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJDZXJ0aWZpY2F0aW9uRGVsZXRlZEV2ZW50SABCBwoFZXZlbnQiZwofRHJpdmVyQ2VydGlmaWNhdGlvbkNyZWF0ZWRFdmVudBJEChRkcml2ZXJfY2VydGlmaWNhdGlvbhgBIAEoCzImLnRyYW5zcG9ydGF0aW9uLnYxLkRyaXZlckNlcnRpZmljYXRpb24ivgEKH0RyaXZlckNlcnRpZmljYXRpb25VcGRhdGVkRXZlbnQSTQodcHJldmlvdXNfZHJpdmVyX2NlcnRpZmljYXRpb24YASABKAsyJi50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJDZXJ0aWZpY2F0aW9uEkwKHHVwZGF0ZWRfZHJpdmVyX2NlcnRpZmljYXRpb24YAiABKAsyJi50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJDZXJ0aWZpY2F0aW9uImcKH0RyaXZlckNlcnRpZmljYXRpb25EZWxldGVkRXZlbnQSRAoUZHJpdmVyX2NlcnRpZmljYXRpb24YASABKAsyJi50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJDZXJ0aWZpY2F0aW9uQkFaP3BhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYW5zcG9ydGF0aW9uL2FwaS92MTt0cmFuc3BvcnRhdGlvbl92MWIIZWRpdGlvbnNw6Ac", [file_transportation_v1_driver_certification]);

/**
 * @generated from message transportation.v1.DriverCertificationEvent
 */
export type DriverCertificationEvent = Message<"transportation.v1.DriverCertificationEvent"> & {
  /**
   * @generated from oneof transportation.v1.DriverCertificationEvent.event
   */
  event: {
    /**
     * @generated from field: transportation.v1.DriverCertificationCreatedEvent created = 1;
     */
    value: DriverCertificationCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: transportation.v1.DriverCertificationUpdatedEvent updated = 2;
     */
    value: DriverCertificationUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: transportation.v1.DriverCertificationDeletedEvent deleted = 3;
     */
    value: DriverCertificationDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message transportation.v1.DriverCertificationEvent.
 * Use `create(DriverCertificationEventSchema)` to create a new message.
 */
export const DriverCertificationEventSchema: GenMessage<DriverCertificationEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification_events, 0);

/**
 * @generated from message transportation.v1.DriverCertificationCreatedEvent
 */
export type DriverCertificationCreatedEvent = Message<"transportation.v1.DriverCertificationCreatedEvent"> & {
  /**
   * @generated from field: transportation.v1.DriverCertification driver_certification = 1;
   */
  driverCertification?: DriverCertification;
};

/**
 * Describes the message transportation.v1.DriverCertificationCreatedEvent.
 * Use `create(DriverCertificationCreatedEventSchema)` to create a new message.
 */
export const DriverCertificationCreatedEventSchema: GenMessage<DriverCertificationCreatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification_events, 1);

/**
 * @generated from message transportation.v1.DriverCertificationUpdatedEvent
 */
export type DriverCertificationUpdatedEvent = Message<"transportation.v1.DriverCertificationUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.DriverCertification previous_driver_certification = 1;
   */
  previousDriverCertification?: DriverCertification;

  /**
   * @generated from field: transportation.v1.DriverCertification updated_driver_certification = 2;
   */
  updatedDriverCertification?: DriverCertification;
};

/**
 * Describes the message transportation.v1.DriverCertificationUpdatedEvent.
 * Use `create(DriverCertificationUpdatedEventSchema)` to create a new message.
 */
export const DriverCertificationUpdatedEventSchema: GenMessage<DriverCertificationUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification_events, 2);

/**
 * @generated from message transportation.v1.DriverCertificationDeletedEvent
 */
export type DriverCertificationDeletedEvent = Message<"transportation.v1.DriverCertificationDeletedEvent"> & {
  /**
   * @generated from field: transportation.v1.DriverCertification driver_certification = 1;
   */
  driverCertification?: DriverCertification;
};

/**
 * Describes the message transportation.v1.DriverCertificationDeletedEvent.
 * Use `create(DriverCertificationDeletedEventSchema)` to create a new message.
 */
export const DriverCertificationDeletedEventSchema: GenMessage<DriverCertificationDeletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification_events, 3);

